import React, { memo, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { CopilotContext, CopilotComment as Comment } from '@Sage/ssm-web5';
import { Button } from '@Sage/hoi-poi-ui';
import sanitizeHtml from 'sanitize-html';
import metadata from 'lib/metadata';
import { getLiteral } from 'utils/getLiteral';

import './styles.scss';

const EmptySummary = ({ onRefreshGoldenMinute, literals }) => {
    const [text, setText] = useState('...');
    const isFirstRender = useRef(true);
    const chatBoxRef = useRef(null);
    const { goldenMinuteCtaViews: ctaViews, updateGoldenMinuteCtaViews: updateCTAViews } =
        useContext(CopilotContext);

    const placeholderText = useMemo(
        () => sanitizeHtml(literals?.emptySummary),
        [literals?.emptySummary],
    );

    const getChatBoxRef = useCallback(({ ref }) => {
        if (!ref) return;
        chatBoxRef.current = ref;
    }, []);

    const getAnimatedPlaceholder = useCallback(() => {
        let text = placeholderText;

        text = text.split('');

        let fullText = '';
        let delay = 35;
        let accumulatedDelay = 100;

        text.forEach((current) => {
            accumulatedDelay = accumulatedDelay + delay;
            setTimeout(() => {
                fullText = `${fullText}${current}`;
                setText(fullText);
            }, accumulatedDelay);
        });
    }, [placeholderText]);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            if (ctaViews === 0) {
                updateCTAViews();
                getAnimatedPlaceholder();
            } else {
                setText(placeholderText);
            }
        }
    }, [getAnimatedPlaceholder, ctaViews, updateCTAViews, placeholderText]);

    return (
        <div className="copilot-golden-minute-empty">
            <div className="copilot-golden-minute-empty__text">
                <Comment
                    text={text}
                    avatar={metadata.SageCopilotIcon}
                    getChatBoxRef={getChatBoxRef}
                    onClick={onRefreshGoldenMinute}
                    isWidget
                />
            </div>
            <div className="copilot-golden-minute-empty__button">
                <Button type="promotion" size="big" onClick={onRefreshGoldenMinute}>
                    {literals?.emptySummaryCTA}
                </Button>
            </div>
        </div>
    );
};

export default memo(EmptySummary);
